/** URLs externas de produto (Netface / legado) — não passam pelo MinIO. */

export function collectExternalProductImageUrls(product: {
  image_url?: string | null;
  sync_metadata?: unknown;
} | null | undefined): string[] {
  if (!product) return [];
  const urls: string[] = [];
  const add = (raw: string | null | undefined) => {
    const url = raw?.trim();
    if (!url || urls.includes(url)) return;
    urls.push(url);
  };

  add(product.image_url);

  const meta = product.sync_metadata as { netface?: { images?: unknown } } | null;
  const images = meta?.netface?.images;
  if (!Array.isArray(images)) return urls;

  for (const entry of images) {
    if (typeof entry === "string") {
      add(entry);
      continue;
    }
    if (entry && typeof entry === "object") {
      const rec = entry as Record<string, unknown>;
      add(
        typeof rec.image_url === "string"
          ? rec.image_url
          : typeof rec.url === "string"
            ? rec.url
            : null,
      );
    }
  }
  return urls;
}
